import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Page } from 'src/app/page';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';

@Component({
  selector: 'app-service-provider-subject-history',
  templateUrl: './service-provider-subject-history.component.html',
  styleUrls: ['./service-provider-subject-history.component.scss']
})
export class ServiceProviderSubjectHistoryComponent implements OnInit {
  page: Page<Object> = new Page();
  selectedRow: { id: number };
  @Input() subjectId!: any;

  displayedColumns: string[] = [
    'dateOfModification',
    'csrName',
    'modifiedBy',
    'registrationId',
    'dateOfCreation',
    'lastName',
    'firstName',
    'parentName',
    'dateOfBirth',
    'yearOfBirth',
    'gender',
    'jmbg',
    'jmbp',
    'statusCsr',
    'statusServiceProvider',
    'familyDossier',
    'familyType',
    'placeOfBirth',
    'nationality',
    'citizenship',
    'category',
    'nativeLanguage',
    'disabledPerson',
    'disabilityType',
    'ableToWork',
    'occupation',
    'employment',
    'education',
    'levelOfEducation',
    'schoolAttending',
    'businessAbility',
    'deprivationExtent',
    'maritalStatus',
    'residence',
    'permanentResidence',
    'phone',
    'mobile',
    'email',
    'note',
    'note1',
    'note2',
    'note3',
    'dossierOwnerCsr',
    'dossierOwnerServiceProvider',
    'familyMembersNames',
  ];
  constructor(
    private paginationService: CustomPaginationService,
    private cdr: ChangeDetectorRef,
    private serviceProviderSubjectService: ServiceProviderSubjectService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.serviceProviderSubjectService.getHistoryPage(this.page.pageable, this.subjectId).subscribe(page => {
      this.page = page;
      this.page.pageable.pagePerShow = page.number + 1;
      for (const element of this.page.content) {
        (element as any).dateOfModification = (element as any).dateOfModification.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
        (element as any).dateOfCreation = (element as any).dateOfCreation.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
        if ((element as any).dateOfBirth !== null) {
          (element as any).dateOfBirth = (element as any).dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
        }
      }
      this.cdr.detectChanges();
    });
  }

  public getNextPage(): void {
    this.page.pageable = this.paginationService.getNextPage(this.page);
    this.getData();
  }

  public getPreviousPage(): void {
    this.page.pageable = this.paginationService.getPreviousPage(this.page);
    this.getData();
  }

  public getFirstPage(): void {
    this.page.pageable = this.paginationService.getFirstPage(this.page);
    this.getData();
  }

  public getLastPage(): void {
    this.page.pageable = this.paginationService.getLastPage(this.page);
    this.getData();
  }

  public getPageInNewSize(pageSize: number): void {
    this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
    this.getData();
  }
}
